import { apiClient } from './client';
import {
    CreateReportCommentPayload,
    CreateReportCommentReplyPayload,
    ReportComment,
    UpdateReportCommentStatusPayload,
} from '@/types/report-comments';

export const reportCommentsApi = {
    list: async (reportId: string): Promise<ReportComment[]> => {
        const response = await apiClient.get<{ data: ReportComment[] }>(
            `/reports/${reportId}/comments`,
        );

        return (response as unknown as { data: ReportComment[] }).data;
    },

    create: async (
        reportId: string,
        payload: CreateReportCommentPayload,
    ): Promise<ReportComment> => {
        const response = await apiClient.post<{ data: ReportComment }>(
            `/reports/${reportId}/comments`,
            payload,
        );

        return (response as unknown as { data: ReportComment }).data;
    },

    reply: async (
        reportId: string,
        commentId: string,
        payload: CreateReportCommentReplyPayload,
    ): Promise<ReportComment> => {
        const response = await apiClient.post<{ data: ReportComment }>(
            `/reports/${reportId}/comments/${commentId}/replies`,
            payload,
        );

        return (response as unknown as { data: ReportComment }).data;
    },

    updateStatus: async (
        reportId: string,
        commentId: string,
        payload: UpdateReportCommentStatusPayload,
    ): Promise<ReportComment> => {
        const response = await apiClient.put<{ data: ReportComment }>(
            `/reports/${reportId}/comments/${commentId}/status`,
            payload,
        );

        return (response as unknown as { data: ReportComment }).data;
    },

    remove: async (reportId: string, commentId: string): Promise<void> => {
        await apiClient.delete(`/reports/${reportId}/comments/${commentId}`);
    },
};
